'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalProductGridItemComponent = exports.rentalProductGridItemComponent = {
    template: require('./rental-product-grid-item.html'),
    bindings: {
        rentalProduct: '<'
    },
    controllerAs: 'vm',
    controller: ["$stateParams", function controller($stateParams) {
        'ngInject';

        var vm = this;
        vm.onOrderedChanged = onOrderedChanged;
        vm.quantityChanged = quantityChanged;
        vm.sellerId = 0;
        vm.$onInit = init;

        function init() {
            vm.sellerId = $stateParams.sellerId;
        }

        function onOrderedChanged() {
            vm.rentalProduct.order ? vm.rentalProduct.quantity = 1 : vm.rentalProduct.quantity = 0;
        }

        function quantityChanged() {
            vm.rentalProduct.quantity > 0 ? vm.rentalProduct.order = true : vm.rentalProduct.order = false;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-product-grid-item.js
// module id = 996
// module chunks = 0